export default __webpack_public_path__ + "static/media/LP-D2-EV.28388e31.jpg";